'use client';

import _slicedToArray from "/codebuild/output/src176/src/s3/01/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { getThumbSize } from './get-thumb-size.mjs';
import { linearScale } from './linear-scale.mjs';
function clamp(value, _ref) {
  var _ref2 = _slicedToArray(_ref, 2),
    min = _ref2[0],
    max = _ref2[1];
  return Math.min(max, Math.max(min, value));
}
function getThumbOffsetFromScroll(scrollPos, sizes) {
  var dir = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "ltr";
  var thumbSizePx = getThumbSize(sizes);
  var scrollbarPadding = sizes.scrollbar.paddingStart + sizes.scrollbar.paddingEnd;
  var scrollbar = sizes.scrollbar.size - scrollbarPadding;
  var maxScrollPos = sizes.content - sizes.viewport;
  var maxThumbPos = scrollbar - thumbSizePx;
  var scrollClampRange = dir === "ltr" ? [0, maxScrollPos] : [maxScrollPos * -1, 0];
  var scrollWithoutMomentum = clamp(scrollPos, scrollClampRange);
  var interpolate = linearScale([0, maxScrollPos], [0, maxThumbPos]);
  return interpolate(scrollWithoutMomentum);
}
export { getThumbOffsetFromScroll };